import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LayoutDocumentLink = ({ layoutId, layoutType = 'pdf' }) => {
    const { t } = useTranslation();

    if (!layoutId)
        return null;

    const path = layoutType === 'email'
        ? `/email_layouts/edit/${encodeURIComponent(layoutId)}`
        : `/layouts/edit/${encodeURIComponent(layoutId)}`;

    return (
        <Link
            to={path}
            className="EmailLayoutsField-edit-link btn btn-sm btn-link DefaultLayoutsForm-layout-link"
            title={t('layouts.references.open_layout')}
        >
            <i className="fa fa-external-link" aria-hidden="true" />
        </Link>
    );
};

export default LayoutDocumentLink;
